module.exports = __webpack_public_path__ + "img/b3-3.9df1baa5.png";